import { ADYEN_HOSTED_CONSTANTS } from '../constants/adyen-hosted.constants';
import { AdyenHostedResultMessage } from '../models/adyen.model';

/**
 * The origin the Calenso return page is served from: the API's own. Only messages from exactly
 * this origin may report a hosted payment - any other window could post the same shape.
 */
export function adyenApiOrigin(apiUrl: string, base: string = window.location.href): string {
  return new URL(apiUrl, base).origin;
}

/**
 * A result for THIS hosted payment, from the Calenso return page. The origin proves who sent it,
 * the nonce which payment it is for; everything else a page could post is ignored.
 */
export function isAdyenHostedResultMessage(
  event: MessageEvent,
  expectedNonce: string,
  expectedOrigin: string,
): event is MessageEvent<AdyenHostedResultMessage> {
  if (event.origin !== expectedOrigin) {
    return false;
  }
  const data = event.data as Partial<AdyenHostedResultMessage> | null;

  return !!data
    && typeof data === 'object'
    && data.source === ADYEN_HOSTED_CONSTANTS.MESSAGE_SOURCE
    && typeof data.nonce === 'string'
    && data.nonce === expectedNonce
    && typeof data.sessionId === 'string'
    && typeof data.sessionResult === 'string'
    && data.sessionResult.length > 0;
}
